import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule, RouteReuseStrategy } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUser,
  faUserInjured,
  faCalendarAlt,
  faCog,
  faBox,
  faClipboardList,
  faChartBar,
  faBars,
  faTimes,
  faHome,
  faCalendarCheck,
  faChevronDown,
  faChevronUp,
  faChevronRight,
  faBell
} from '@fortawesome/free-solid-svg-icons';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from '@shared/shared.module';
import { PatientDetailOverlayHostModule } from '@shared/patient-detail-overlay-host.module';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { AppStatusFooterComponent } from './layouts/app-status-footer/app-status-footer.component';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { ChangeDetectionInterceptor } from './core/interceptors/change-detection.interceptor';
import { GlobalErrorHandler } from './core/errors/global-error.handler';
import { PatientListReuseStrategy } from './core/routes/patient-list-reuse.strategy';

library.add(
  faHome,
  faUser,
  faUserInjured,
  faCalendarAlt,
  faCalendarCheck,
  faCog,
  faBox,
  faClipboardList,
  faChartBar,
  faBars,
  faTimes,
  faChevronDown,
  faChevronUp,
  faChevronRight,
  faBell
);

@NgModule({
  declarations: [
    AppComponent,
    MainLayoutComponent,
    AppStatusFooterComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    PatientDetailOverlayHostModule,
    FontAwesomeModule
  ],
  providers: [
    CookieService,
    {
      provide: RouteReuseStrategy,
      useClass: PatientListReuseStrategy
    },
    // Register GlobalErrorHandler to catch chunk load errors and other unhandled errors
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    // Register ChangeDetectionInterceptor first so it runs last on responses
    // This ensures change detection is triggered after all other interceptors
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ChangeDetectionInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
